<template>
  <v-app>
    <v-container class="fill-height" style="justify-content: center">
      <v-card class="mx-auto">
        <v-card-text>
          <v-img
            align="center"
            justify="center"
            class="mt-10"
            :transition="false"
            :aspect-ratio="
              this.$store.getters.getLogo.path === 'sentinel' ? 9 : 14
            "
            contain
            :src="
              require(`@/assets/${this.$store.getters.getLogo.path}/logo.png`)
            "
          />
        </v-card-text>
        <v-card-title> We'll be back soon! </v-card-title>
        <v-card-text>
          <i18n
            path="general.underMaintenance.sorryForTheInconvenienceButWeRePerformingSomeMaintenanceAtTheMomentIfYouNeedToYouCanAlwaysOtherwiseWellBeBackOnlineShortly"
            tag="p"
          >
            <template v-slot:mailTo>
              <a :href="`mailto:${getLinks.supportEmail}`">{{
                $t("general.underMaintenance.contactUs")
              }}</a>
            </template>
          </i18n>
          <p>
            {{ $t("general.underMaintenance.theSentinelTeam") }}
          </p>
        </v-card-text>
      </v-card>
    </v-container>
  </v-app>
</template>
<script>
import { mapGetters } from "vuex";
import api from "@/utils/api";
export default {
  data() {
    return {};
  },

  computed: {
    ...mapGetters(["getLinks"]),
  },

  created() {
    this.checkHealthStatus();
  },

  methods: {
    async checkHealthStatus() {
      try {
        const { data } = await api.healthcheck();
        if (data.status === "ONLINE") {
          this.$router.push({ name: "base" });
          return;
        }
      } catch (error) {
        const randomJitter = Math.floor(Math.random() * 10000) + 1;

        setTimeout(() => {
          this.checkHealthStatus();
        }, 30000 + randomJitter);
      }

      const randomJitter = Math.floor(Math.random() * 10000) + 1;

      setTimeout(() => {
        this.checkHealthStatus();
      }, 30000 + randomJitter);
    },
  },
};
</script>
<style lang=""></style>
